import { Card, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InputControl from "../../../shared/components/InputControl";
import { Loader, LoadingButton } from "../../../shared";

// State and handlers come from `useFullTaxInvoice` in FullTaxInvoicePage
export const FullTaxInvoiceSettings = ({
  state,
  settingsValidator,
  handleSettingsChange,
  handleSettingsSubmit,
}) => {
  const { settings } = state;

  const daysValidation = settingsValidator.current.message(
    "Days",
    settings.formData.request_period_days,
    "required|integer|min:1,num",
  );

  return (
    <Card sx={{ p: "24px" }}>
      {settings.isLoading ? (
        <Stack height="80px" justifyContent="center" alignItems="center">
          <Loader />
        </Stack>
      ) : (
        <Stack direction={{ xs: "column", md: "row" }} gap="24px">
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ width: { md: "200px" }, flexShrink: 0, pt: { md: "14px" } }}
          >
            FTI Request Period
          </Typography>
          <Stack gap="6px" flex={1}>
            <InputControl
              type="number"
              name="request_period_days"
              label="Days from order date."
              value={settings.formData.request_period_days}
              onChange={handleSettingsChange}
              isDisabledKeys={[".", "-"]}
              error={!!daysValidation}
              helperText={daysValidation}
            />
            <Stack direction="row" gap="6px" color="text.secondary">
              <InfoOutlinedIcon sx={{ fontSize: 15, mt: "2px" }} />
              <Typography variant="caption">
                Set how many days after the order date an FTI can be issued or
                reprinted. After this period, these actions are unavailable.
              </Typography>
            </Stack>
          </Stack>
          <LoadingButton
            variant="contained"
            sx={{
              alignSelf: "flex-end",
              width: { xs: "100%", sm: "max-content" },
            }}
            onClick={handleSettingsSubmit}
            loading={settings.isSubmitting}
            disabled={!settings.hasChanges}
          >
            Save
          </LoadingButton>
        </Stack>
      )}
    </Card>
  );
};
